var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.logoList.length || _vm.setInitLogos.length,
      expression: "logoList.length || setInitLogos.length"
    }],
    ref: "logoRef",
    class: {
      edit: _vm.State.showUploadLogo
    },
    attrs: {
      "id": "logoConfig"
    }
  }, [_c('main', {
    staticClass: "logoArea"
  }, [_vm.isAppliedImg ? _c('div', _vm._l(_vm.setInitLogos, function (item) {
    return _c('vue-draggable-resizable', {
      key: item.id,
      attrs: {
        "h": item.realHeight ? item.realHeight : 66,
        "w": item.realWidth ? item.realWidth : 66,
        "x": item.realX ? item.realX : 0,
        "y": item.realY ? item.realY : 0,
        "parent": true,
        "lockAspectRatio": true,
        "draggable": false,
        "resizable": false,
        "class-name": _vm.returnClass
      }
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    })]);
  }), 1) : _c('div', _vm._l(_vm.logoList, function (item) {
    return _c('vue-draggable-resizable', {
      key: item.name,
      attrs: {
        "h": item.realHeight ? item.realHeight : 66,
        "w": item.realWidth ? item.realWidth : 66,
        "x": item.realX ? item.realX : 0,
        "y": item.realY ? item.realY : 0,
        "parent": true,
        "lockAspectRatio": true,
        "draggable": _vm.showUploadLog,
        "resizable": _vm.showUploadLog,
        "class-name": _vm.returnClass
      },
      on: {
        "dragging": (x, y) => {
          _vm.onDrag(x, y, item);
        },
        "resizing": (x, y, width, height) => {
          _vm.onResize(x, y, width, height, item);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    })]);
  }), 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };